import { render } from "./PortfolioIndex.vue?vue&type=template&id=223cc5ec"
import script from "./PortfolioIndex.vue?vue&type=script&lang=js"
export * from "./PortfolioIndex.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Kyler\\OneDrive\\Website\\website2022\\development\\kylerherrera-2022\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__